export const MONTH_LABELS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]

const MONTHS_PER_YEAR = 12

export const isCalendarMonth = (yyyymm: number): boolean => {
  const month = yyyymm % 100

  return month >= 1 && month <= MONTHS_PER_YEAR
}

export const formatMonth = (yyyymm: number): string => {
  const year = Math.floor(yyyymm / 100)
  const month = yyyymm % 100
  const label = MONTH_LABELS[month - 1]

  if (label === undefined) {
    return String(yyyymm)
  }

  return `${label} ${String(year % 100).padStart(2, '0')}`
}

export const monthToOrdinal = (yyyymm: number): number =>
  Math.floor(yyyymm / 100) * MONTHS_PER_YEAR + ((yyyymm % 100) - 1)

export const ordinalToMonth = (ordinal: number): number => {
  const year = Math.floor(ordinal / MONTHS_PER_YEAR)
  const month = (ordinal % MONTHS_PER_YEAR) + 1

  return year * 100 + month
}

export const formatMonthOrdinal = (ordinal: number): string => formatMonth(ordinalToMonth(ordinal))

export const monthsInWindow = (startMonth: number, endMonth: number): number[] => {
  const start = monthToOrdinal(startMonth)
  const end = monthToOrdinal(endMonth)

  if (end < start) {
    return []
  }

  return Array.from({ length: end - start + 1 }, (_, offset) => ordinalToMonth(start + offset))
}

export const lastCompleteMonth = (months: readonly number[]): number | null => months.at(-2) ?? null
